export default "__VITE_ASSET__56ca2191__"